export default {
  LeftMenu: {

  },
  Nav: {

  },
  Title: {
  },
}
